import { PublicClientApplication } from "@azure/msal-browser";
const msalConfig = {
    auth: {
      clientId: "4fa364c3-54e6-462d-ab43-332ae27c7665",
      authority: "https://login.microsoftonline.com/392a0e68-d781-47f6-8e34-a09971f1cd63",
      redirectUri: "https://dislog.hpc-hamburg.de/login",
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      pollIntervalMilliseconds: 0,
    }
  };

  export const msalInstance = new PublicClientApplication(msalConfig);